import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import { CheckCircle } from 'lucide-react';
import type React from 'react';

interface AppointmentStep3Props {
  onContinue: () => void;
  t: (key: string) => string;
}

export const AppointmentStep3: React.FC<AppointmentStep3Props> = ({ onContinue, t }) => {
  return (
    <Stack alignItems="center" spacing={3} width="100%">
      <Avatar
        sx={{
          width: 64,
          height: 64,
          bgcolor: 'success.main',
        }}
      >
        <CheckCircle size={32} color="#fff" />
      </Avatar>

      <Typography variant="h5" component="h2" textAlign="center" fontWeight="bold">
        {t('scheduling.appointment.meetingSet')}
      </Typography>

      <Typography variant="body1" color="text.secondary" textAlign="center">
        {t('scheduling.appointment.invitationSent')}
      </Typography>

      <Box sx={{ width: '100%', mt: 2 }}>
        <Button variant="contained" color="primary" fullWidth onClick={onContinue}>
          {t('scheduling.appointment.continueStep3')}
        </Button>
      </Box>
    </Stack>
  );
};
